import React from "react";
import ReactGa from "react-ga4";

const VideoComponent = (props) => {
    // console.log("[VideoComponent]", props.id, props.src)

    //This is part of the Google Analytics Module
    const recordGoogleAnalytics = () => {
        // console.log("[VideoComponent ReactGa]", props.id, props.src)
        ReactGa.event({
            category: 'Video/Audio Component',
            action: `User clicked a(n) video/audio ${props.src}`,
        });
    }

    return (
        <div>
            {props.audio === 'Y' ?

                <audio  id={props.id} hidden onPlay={recordGoogleAnalytics}>
                    <source src={props.src} type="audio/ogg"/>
                    <source src={props.src} type="audio/mpeg"/>
                    Your browser does not support the audio element.
                </audio>
                :
                <video id={props.id} playsInline style={{display: 'none'}} controls controlsList="nodownload noremoteplayback"
                       onPlay={recordGoogleAnalytics}>
                    <source src={props.src} type='video/mp4 "avc1.42E01E, mp4a.40.2"'/>
                    <source src={props.src} type='video/ogg codecs="theora, vorbis"'/>
                    <source src={props.src} type="application/x-mpegURL"/>
                </video>
            }
        </div>
    )
}

export default VideoComponent;
